import React from "react";
import Navbar from "./navbar";

const About = () => {
  return (
    <div>
      <Navbar />
      <h1>About Page</h1>
    </div>
  );
};

export default About;
